import { replica } from '@/shared/sync/replica';

export async function revokeSession(id: string): Promise<void> {
  await replica.http.json<void>(`/sessions/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
